module.exports = class Slick {
  constructor(id) {
    const $el = window.jQuery(`#${id}`);
    $el.slick($el.data('slick'));
  }
}